import { css as t } from "styled-components";
import { MediaQuery as d, ContainerPadding as i, Container as a } from "./variables.js";
const r = t`
  width: 100%;
  margin-right: auto;
  margin-left: auto;

  @media ${d.SCREEN_MD_UP} {
    padding-right: ${i.MD}px;
    padding-left: ${i.MD}px;
  }

  @media ${d.SCREEN_LG_UP} {
    padding-right: ${i.LG}px;
    padding-left: ${i.LG}px;
  }

  @media ${d.SCREEN_XL} {
    padding-right: ${i.XL}px;
    padding-left: ${i.XL}px;
    max-width: ${a.MAX + i.XL * 2}px;
  }
`;
export {
  r as containerStyle
};
